import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, Loader } from 'semantic-ui/semantic-ui-imports';
import './index.scss';
import { useAuth } from '../../../contexts/auth';
import { User } from '../../../Types/User';

const className = 'request-details';

interface Props {
  name?: string;
  alternativeToName?: string | null;
  userId?: string | number;
  message?: string;
}

function OfferRequestDetails({
  name,
  alternativeToName,
  userId,
  message,
}: Props) {
  const { t } = useTranslation();

  const [isLoading, setLoading] = React.useState<boolean>(false);
  const [resultUser, setResultUser] = React.useState<User | null>(null);
  const [userNotFound, setUserNotFound] = React.useState<boolean>(false);

  const { getProfile } = useAuth();

  const getUserDetails = async () => {
    if (!userId) {
      setUserNotFound(true);
      return;
    }
    setLoading(true);
    try {
      const user = await getProfile(userId);
      if (user) {
        setResultUser(user);
      } else {
        setUserNotFound(true);
      }
    } catch (err) {
      // User likely deleted - show what we can
      setUserNotFound(true);
    }
    setLoading(false);
  };

  React.useEffect(() => {
    getUserDetails();
  }, [userId]);

  return (
    <div className={className}>
      <h1>{t('resultsPage.requestDetails.title')}</h1>
      <Loader active={isLoading} />
      {!isLoading && (
        <div className="request-offer__inner">
          <Table celled>
            <Table.Body>
              <Table.Row verticalAlign="top">
                <Table.Cell>
                  <b>{t('resultsPage.requestDetails.name')}</b>
                </Table.Cell>
                <Table.Cell>
                  {name}
                  {alternativeToName && (
                    <p style={{ color: '#888', fontStyle: 'italic' }}>
                      {t('resultList.alternativeTo', {
                        name: alternativeToName,
                      })}
                    </p>
                  )}
                </Table.Cell>
              </Table.Row>
              <Table.Row verticalAlign="top">
                <Table.Cell>
                  <b>{t('resultsPage.requestDetails.requestedBy')}</b>
                </Table.Cell>
                <Table.Cell>
                  {resultUser && (
                    <>
                      <p>
                        {resultUser.first_name} {resultUser.last_name}
                      </p>
                      <p>{resultUser.address} </p>
                      <p>
                        {resultUser.postal_code}, {resultUser.city}
                      </p>
                      <p>E-mail: {resultUser.email || '-'}</p>
                      <p>Tel.: {resultUser.tel}</p>
                    </>
                  )}
                  {!resultUser && userNotFound && (
                    <p style={{ color: '#888', fontStyle: 'italic' }}>
                      {t('resultsPage.requestDetails.userDeleted')}
                    </p>
                  )}
                </Table.Cell>
              </Table.Row>
              <Table.Row verticalAlign="top">
                <Table.Cell>
                  <b>{t('resultsPage.requestDetails.message')}</b>
                </Table.Cell>
                <Table.Cell>{message || '-'}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      )}
    </div>
  );
}

OfferRequestDetails.defaultProps = {
  name: '',
  alternativeToName: null,
  message: '',
  userId: null,
};

export default OfferRequestDetails;
